export default __webpack_public_path__ + "static/media/cart.f9b9dc4b.svg";